import React, { useState } from "react";
import axios from 'axios';
import "./web.css";
import pyconfig from "../config";
import { ToastContainer ,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import file from "../pages/file.png"
function Avataruplode() {
  const [name, setName] = useState("");
  const [gender, setGender] = useState("male");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handlesubmit = async () => {
     
    if (loading) return; 

    try {
      setLoading(true);   

     const responseImg = await fetch(file);
     const blob = await responseImg.blob();
     const imageFile = new File([blob], "file.png", { type: blob.type });

      const formData = new FormData();
      formData.append("image", imageFile);  

      const response = await axios.post(`${pyconfig.apiBaseUrl}/webrtc/start`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
       const { message, stream_id,session_id,ice_servers,offer } = response.data;
      toast.success(message|| "Avatar created successfully");
       navigate("/webrtc", {
        state: {
          name,
          gender,          
          stream_id,session_id:session_id,
          ice_servers,offer
        },
      });
    } catch (err) {
      console.error(err);
      toast.error("Failed to create avatar");
    }finally {
      setLoading(false);                                   
      setName("");
      setGender("male");
    }
  };

  return (
    <div className="home-section-dm p-3">
        <ToastContainer/>
        <div className="row h-100 align-items-center">
            <div className="col-lg-6 col-12 d-flex justify-content-center">
        <div className="glass-card">
        <h2 className="card-title">AI Avatar</h2>
  
        <label className="field">
          <span className="field-label">Avatar Name</span>
          <input
            className="text-input"
            placeholder="Type a name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </label>

        <div className="field">
          <span className="field-label">Gender</span>
          <div className="gender-toggle" role="radiogroup" aria-label="Gender">
            <input
              id="male"
              type="radio"
              name="gender"
              value="male"
              checked={gender === "male"}
              onChange={() => setGender("male")}
            />
            <label htmlFor="male">Male</label>

            <input
              id="female"
              type="radio"
              name="gender"
              value="female"
              checked={gender === "female"}
              onChange={() => setGender("female")}
            />
            <label htmlFor="female">Female</label>

            <span className={`toggle-indicator ${gender}`} />
          </div>
        </div>
      <button className="primary-btn-av"  onClick={handlesubmit}      disabled={loading} > {loading ? "Sending..." : "Start Interaction"}</button>
      </div>
        </div>
         <div className="col-lg-6 col-12"></div>
        </div>
    </div>
  );
}

export default Avataruplode;
